import { hasValue } from 'swipeclock-frontend';
import { FORM_IDS } from 'providers/PasswordResetProvider';
import { validatePassword } from 'helpers/validatePassword';

const validationCallback = (id, value, ref) => {
  let error = null;
  switch (id) {
    case FORM_IDS.CURRENT_PASSWORD:
      if (!hasValue(value)) {
        error = 'Current Password is required.';
      } else if (value.length > 50) {
        error = 'Current Password cannot exceed 50 characters.';
      }
      break;
    case FORM_IDS.PASSWORD:
      if (!hasValue(value)) {
        error = 'Password is required.';
      } else if (value.length > 50) {
        error = 'Password cannot exceed 50 characters.';
      } else {
        const { pass, error: passwordError } = validatePassword(value);
        if (!pass) {
          error = passwordError;
        }
      }
      break;
    case FORM_IDS.CONFIRM_PASSWORD:
      if (!hasValue(value)) {
        error = 'Confirm Password is required.';
      } else if (value !== ref.current[FORM_IDS.PASSWORD]?.value) {
        error = 'Password and Confirm Password must match.';
      }
      break;
    default:
      break;
  }
  return error;
};

export function usePasswordValidationCallback() {
  return validationCallback;
}
